import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import EditorialDepthSlider from "@/components/EditorialDepthSlider";
import GoogleReviews from "@/components/GoogleReviews";
import BlogSection from "@/components/BlogSection";
import DifferentiatorsSection from "@/components/DifferentiatorsSection";
import FAQSection from "@/components/FAQSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import RealInstagramFeed from "@/components/RealInstagramFeed";
import LocalBusinessSchema from "@/components/LocalBusinessSchema";
import HomeStructuredData from "@/components/HomeStructuredData";

const Index = () => {
  return (
    <main className="min-h-screen">
      <LocalBusinessSchema />
      <HomeStructuredData />
      <Header />
      <HeroSection />
      <AboutSection />
      <EditorialDepthSlider />
      <ServicesSection />
      <GoogleReviews />
      <RealInstagramFeed />
      <DifferentiatorsSection />
      <FAQSection />
      <ContactSection />
      <Footer />
    </main>
  );
};

export default Index;
